import { Navigate } from "react-router-dom";
import ServicesList from "../components/servicesList";
import ServiceCreate from "../components/servicesCreate";
import ServiceEditView from "../components/servicesEditView";
import SvgIcons from "../../../shared/components/svgIcons";

const serviceRoutes = [
  {
    path: "services",
    element: <ServicesList />,
    link: "services",
    name: "Services",
    permission: "Service",
    icon: SvgIcons.ServiceProviderIcon,
    index: 3,
  },
    {
      path: "services/:id",
      element: <ServiceEditView />,
    },
    {
      path:"services/create",
      element: <ServiceCreate />
    },
  {
    path: "*",
    element: <Navigate to="services" replace />,
  },
];

export default serviceRoutes;
